<template>
  <div >
    <h3 class="pricing-table-title">Total</h3>
    <div class="row border-t border-grey-base">
      <div class="col">
        {{ adultsPriceCalc }}
      </div>
      <div class="col text-right">
        {{ adultsTotalPrice }}
      </div>
    </div>
    <div class="row flex border-t border-grey-base">
      <div class="col">
        {{ childrenPriceCalc }}
      </div>
      <div class="col text-right">
        {{ childrenTotalPrice }}
      </div>
    </div>
    <div class="row border-b border-t border-grey-base">
      <div class="col">
        {{ singleRoomsCalc }}
      </div>
      <div class="col text-right">
        {{ singleRoomsTotal }}
      </div>
    </div>
    <div class="row">
      <div class="col font-semibold">Total price</div>
      <div class="col text-right">
        {{ totalPrice }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TotalPriceSummary",
  props: {
    tripDetails: {
      type: Object,
      required: true
    }
  },
  methods:{

    formatNumber(value, currency, region) {
      value = new Intl.NumberFormat(region, {
        style: "currency",
        currency: currency || "USD",
      }).format(value);
      return value;
    },
  },
  computed:{
    pricePerChild() {
      let total = this.tripDetails.tripPricePerChild;
      return this.formatNumber(
          total,
          this.tripDetails.tripCurrency,
          this.region
      );
    },
    childrenPriceCalc() {
      let isPlural =
          this.tripDetails.tripChildren > 1 ||
          this.tripDetails.tripChildren == 0;
      let price = this.pricePerChild || 0;
      let numOfAChildren = this.tripDetails.tripChildren || 0;
      return `${price} x ${numOfAChildren} ${isPlural ? "children" : "child"}`;
    },
    singleRoomsCalc() {
      let isPlural =
          this.tripDetails.tripSingleRooms > 1 ||
          this.tripDetails.tripSingleRooms == 0;
      let price = this.singleRoomPriceFormatted || 0;
      let numOfRooms = this.tripDetails.tripSingleRooms || 0;
      return `${price} x ${numOfRooms} single ${isPlural ? "rooms" : "room"}`;
    },
    childrenTotalPrice() {
      let total =
          this.tripDetails.tripPricePerChild * this.tripDetails.tripChildren;
      return this.formatNumber(
          total,
          this.tripDetails.tripCurrency,
          this.region
      );
    },
    numberOfTravelers() {
      return this.tripDetails.tripChildren + this.tripDetails.tripAdults;
    },
    priceFormatted() {
      let total = this.tripDetails.tripBudget;
      return this.formatNumber(
          total,
          this.tripDetails.tripCurrency,
          this.region
      );
    },
    singleRoomPriceFormatted() {
      let total = this.tripDetails.tripSingleRoomPrice;
      return this.formatNumber(
          total,
          this.tripDetails.tripCurrency,
          this.region
      );
    },
    pricePerAdult() {
      let total = this.tripDetails.tripPricePerAdult;
      return this.formatNumber(
          total,
          this.tripDetails.tripCurrency,
          this.region
      );
    },
    adultsPriceCalc() {
      let isPlural =
          this.tripDetails.tripAdults > 1 || this.tripDetails.tripAdults === 0;
      let price = this.pricePerAdult || 0;
      let numOfAdults = this.tripDetails.tripAdults || 0;
      return `${price} x ${numOfAdults} ${isPlural ? "adults" : "adult"}`;
    },
    adultsTotalPrice() {
      let total =
          this.tripDetails.tripPricePerAdult * this.tripDetails.tripAdults;
      return this.formatNumber(
          total,
          this.tripDetails.tripCurrency,
          this.region
      );
    },
    singleRoomsTotal() {
      let total =
          this.tripDetails.tripSingleRoomPrice *
          this.tripDetails.tripSingleRooms;
      return this.formatNumber(
          total,
          this.tripDetails.tripCurrency,
          this.region
      );
    },
    totalPrice() {
      let adultsTotalPrice =
          this.tripDetails.tripPricePerAdult * this.tripDetails.tripAdults;
      let childrenTotalPrice =
          this.tripDetails.tripPricePerChild * this.tripDetails.tripChildren;
      let totalTravelersPrice = childrenTotalPrice + adultsTotalPrice;
      let roomPrice =
          this.tripDetails.tripSingleRoomPrice *
          this.tripDetails.tripSingleRooms;
      let total = totalTravelersPrice + roomPrice;
      return this.formatNumber(
          total,
          this.tripDetails.tripCurrency,
          this.region
      );
    },
  }
}
</script>

<style scoped>
.pricing-table-title {
  @apply font-sans font-semibold text-base sm:text-xl mb-3;
}
.row {
  @apply flex justify-between py-2;
  @apply text-sm sm:text-base;
}
.col {
  @apply w-1/2;
}
</style>